import { isDefined } from '@app/utils/is';
import { isEmpty } from '@app/utils/isEmpty';

interface Props<T, K> {
  title?: string;
  data: T;
  labels: [K, string][];
}

export const DataPreview = <T extends Record<K, string | number | null | undefined>, K extends keyof T>({
  title,
  data,
  labels,
}: Props<T, K>) => (
  <div className="rounded-regular bg-neutral-98 p-4 text-neutral-20">
    {isDefined(title) && !isEmpty(title) && <div className="mb-2 heading-3">{title}</div>}
    <dl>
      {labels.map(([key, label]) => (
        <div key={key.toString()} className="flex gap-1">
          <dt className="text-neutral-40">{label}:</dt>
          <dd data-sentry-mask>{!isDefined(data[key]) || data[key] === '' ? '-' : data[key]}</dd>
        </div>
      ))}
    </dl>
  </div>
);
